<template>
  <div id="replace" >
    <div class="title" >绑定手机</div>
    <div class="from" >
      <van-field
        v-model="beforeInfo.tel"
        :error-message="validator.ErrMsg.tel"
        clearable
        placeholder="请输入新手机号码">
      </van-field>
      <van-field
        v-model="beforeInfo.code"
        :error-message="validator.ErrMsg.code"
        type="code"
        placeholder="请输入验证码">
        <van-button
          @click="getSmsCode()"
          slot="button"
          size="small"
          type="primary">
          {{ time ? time + 's后重新获取' : '发送验证码' }}
        </van-button>
      </van-field>
      <van-button
        @click="updateBindMobile()"
        size="large"
        class="btn-reg">
        完成</van-button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Validator from '@/libs/validator'
import { changeBindingCode, changeBindingNewMobile, updateRegisterMobile } from '@/api/user'
import { getUserInfo, getToken, setToken, setUserInfo } from '@/libs/cookie-storage'
import { Field, Toast } from 'vant'
Vue.use(Field)
export default {
  name: 'ReplacePhone',
  data() {
    return {
      time: null,
      afterTime: null,
      beforeInfo: {
        tel: '',
        code: ''
      },
      rules: {
        tel: [
          {
            validator: (rule, value, callBack) => {
              if (!value) {
                callBack('请输入手机号码')
              } else if (/^[1][0-9]{10}$/.test(value)) {
                callBack()
              } else {
                callBack('请输入正确的手机号码')
              }
            }
          }
        ],
        code: [
          { required: true, message: '验证码不能为空' }
        ]
      }
    }
  },
  created() {
    this.validator = new Validator({
      rules: this.rules,
      data: this.beforeInfo
    })
    this.beforeInfo = this.validator.Data
  },
  mounted() {},
  methods: {
    getSmsCode() {
      if (this.time) {
        return
      }
      this.validator.validate('tel').then(
        (res) => {
          changeBindingCode(this.beforeInfo.tel).then(
            (resolve) => {
              let sms = resolve.data.isSent
              if (sms) {
                this.countDown()
              }
            },
            (reject) => { console.log(reject) }
          )
        },
        (rej) => {
          this.$set(this.beforeInfo, rej.field)
          return false
        }
      )
    },
    countDown() {
      this.time = 60
      let date = setInterval(() => {
        if (this.time <= 1) {
          this.time = null
          clearInterval(date)
          return
        }
        this.time -= 1
      }, 1000)
    },
    updateBindMobile() {
      this.validator.validate(['tel', 'code']).then(
        () => {
          changeBindingNewMobile(this.beforeInfo.tel, this.beforeInfo.code).then((resolve) => {
            let data = resolve.data
            if (resolve) {
              if (data.session && data.session.id) {
                setToken(data.session.id)
                setUserInfo(data.user)
                this.$store.commit('SET_TOKEN', data.session.id)
                this.$store.commit('SET_INFO', data.user)
              }
              Toast('绑定手机成功')
              this.$router.go(-1)
            }
            /*
            let tel = getUserInfo().mobile
            let token = getToken()
            let data = resolve.data
            let params = {
              id: data.user.id,
              loginName: tel,
              passport: token
            }
            /*
            updateRegisterMobile(params).then((resolve) => {
              if (resolve) {
                if (data.session && data.session.id) {
                  setToken(data.session.id)
                  setUserInfo(data.user)
                  this.$store.commit('SET_TOKEN', data.session.id)
                  this.$store.commit('SET_INFO', data.user)
                }
                Toast('修改手机号成功')
              }
            })
            */
          })
        },
        (rej) => {
          this.$set(this.beforeInfo, rej[0].field)
        }
      )
    }
  }
}
</script>
<style>
  #replace {
    margin: 0 0.3rem;
  }

  #replace .title {
    font-size: 36px;
    color: #185494;
    font-weight:500;
    text-align: center;
    padding: 15px;
  }

  #replace .btn {
    margin-top: 30px;
  }

  #replace .van-field__body {
    height: 50px;
    line-height: 50px;
    background:rgba(248,248,248,1);
  }

  #replace .van-field__body .van-field__control {
    text-indent: 15px;
    font-size: 16px;
  }

  #replace .van-cell:not(:last-child)::after {
    border-bottom: none;
  }

  #replace .van-cell {
    padding: 8px 0;
  }

  #replace .van-field__body .van-field__button:before {
    content: '';
    position: absolute;
    width: 1px;
    height: 30px;
    background-color: #CFCFCF;
    top: 10px;
  }

  #replace .van-field__body .van-field__button .van-button {
    background-color: transparent;
    border: none;
    color: #185494;
    padding: 0 15px;
  }

  #replace .van-field__error-message {
    text-indent: 15px;
  }

  #replace .btn-reg+a {
    color:rgba(129,129,129,1);
  }

  #replace .btn-reg {
    height:60px;
    background:#185494;
    border-radius:2px;
    border: none;
    margin-top: 30px;
    font-weight:400;
    color:white;
    font-size:20px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/ucenter/replace-phone.vue